import { PreviewType } from '@/components/pc/previews/type';
import Attachment from './attachment';
import intl from '@/internationalzation/intl';
export default {
  tag: 'attachment',
  format: intl.t(
    '!@[后缀](resourceId=文件ID&resourceName=文件名&resourceSize=文件尺寸&pdfKey=pdfKey&resourceUrl=文件URL)',
    {},
  ),
  sourcePipeline: (source: string) => {
    return source.replace(
      /!@\[([^\]]+)\]\(resourceId=([^&]+)&resourceName=([^&]+)&resourceSize=(\d+)&pdfKey=([^&]*)&resourceUrl=([^\)]*)\)/g,
      (
        match,
        fileType,
        resourceId,
        resourceName,
        resourceSize,
        pdfKey,
        resourceUrl,
      ) => {
        if (fileType === PreviewType.PDF && !resourceName.endsWith('.pdf')) {
          resourceName = `${resourceName}.pdf`;
        }
        if (fileType === PreviewType.DOCX && !resourceName.endsWith('.docx')) {
          resourceName = `${resourceName}.docx`;
        }
        if (fileType === PreviewType.TEXT && !resourceName.endsWith('.txt')) {
          resourceName = `${resourceName}.txt`;
        }
        if (fileType === PreviewType.XLSX && !resourceName.endsWith('.xlsx')) {
          resourceName = `${resourceName}.xlsx`;
        }
        // 构建属性对象
        const attrs = {
          fileType: fileType,
          resourceId: resourceId,
          resourceName: resourceName,
          resourceSize: resourceSize,
          pdfKey: pdfKey,
          fileUrl: decodeURIComponent(resourceUrl),
        };
        // 转换为自定义HTML标签
        return `<attachment suffix="${attrs?.fileType}" id="${attrs?.resourceId}" title="${attrs.resourceName}" size="${attrs.resourceSize}" pdfkey="${attrs?.pdfKey}" fileUrl="${attrs?.fileUrl}"></attachment>`;
      },
    );
  },
  componentFn: (node: any) => {
    return (
      <Attachment
        suffix={node.suffix}
        id={node.id}
        title={decodeURIComponent(node.title)}
        size={node.size}
        pdfKey={node.pdfkey}
        fileUrl={node.fileurl}
      />
    );
  },
};
